import React, { useState, useEffect, useCallback } from "react";
import LoadingScreen from "../../Shared/LoadingScreen";
import Table from "../../Shared/Table";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import Chip from "../../Shared/StatusChip";
import { PrimaryButton } from "../../Shared/Buttons";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import ModalComp from "../../Shared/ModalComp";
import AddRestaurant from "../AddRestaurant/AddRestaurant";
import { FormControl, MenuItem, Select, Typography } from "@material-ui/core";
import ConfirmationModal from "../../Shared/ConfimationModal";
import RestDataAction from "../../Store/Actions/GetRestaurant-Action";
import { RestaurantAction } from "../../Store/Reducers/Restaurant-reducer";
import { useSelector, useDispatch } from "react-redux";
import { BtnStyle } from "../../Util/CSS/BtnStyle";
import LoadMoreItems from "../../Shared/LoadMoreItemsScreen";
import { useErrorHandler } from "react-error-boundary";
import SearchComp from "../../Shared/GlobalSearch";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  newRestDiv: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse",
    width: "100%",
  },
}));

export default function VersionControl1() {
  const {
    restaurantData,
    searchRestaurant,
    showSearch,
    loading,
    status,
    isLoaded,
    lastEvaluatedkey,
    loadMore,
  } = useSelector((state) => state.Restaurant);
  const dispatch = useDispatch();
  let classes = useStyles();
  const history = useHistory();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });
  const ErrorHandler = useErrorHandler();
  const styles = BtnStyle();
  const [openModal, setopenModal] = useState(false);
  const [isOpen, setisOpen] = useState({
    open: false,
    content: "",
    deleteHandler: "",
    item: "",
  });
  useEffect(() => {
    dispatch(RestaurantAction.setShowSearch(false));
    if (!isLoaded) {
      dispatch(RestDataAction(lastEvaluatedkey));
      dispatch(RestaurantAction.setIsLoaded(true));
    }
  }, [isLoaded]);

  useEffect(() => {
    if (status !== "") {
      ErrorHandler(() => {
        throw new Error(status);
      });
      handleSnackbarOpen(status, "errorDark");
    }
    return () => {
      setSnackbarOpen(false);
      setSnackbarDetails({
        message: "",
        type: "",
      });
    };
  }, [status]);
  const getTime = (time) => {
    let key = parseInt(time);
    return (
      new Date(key).toDateString() +
      " " +
      new Date(key).getHours() +
      ":" +
      new Date(key).getMinutes() +
      ":" +
      new Date(key).getSeconds()
    );
  };
  const [version, setVersion] = useState([]);
  useEffect(() => {
    if (!version.length) {
      axios
        .get(`${process.env.REACT_APP_API_URL}canary/version`)
        .then((response) => {
          if (response && response.data && response.data.data) {
            console.log("Version Data Fetched:", response.data.data);
            setVersion(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching version data:", error);
          handleSnackbarOpen("Failed to fetch version data", "errorDark");
        });
    }
  }, [version]);
  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };
  const handleApplyVersion = (name, id, event) => {
    try {
      let selectedVersion = event.target.value;

      if (!selectedVersion) {
        handleSnackbarOpen("Version not selected", "errorDark");
        return;
      }
      axios
        .post(`${process.env.REACT_APP_API_URL}/restaurant/version`, {
          names: [{ title: name, id }],
          version: selectedVersion,
        })
        .then((res) => {
          // let resData = restaurantData.map((res) =>
          //   res.id === id ? { ...res, version } : res
          // );
          // dispatch(RestaurantAction.changeStatus(resData));
          handleSnackbarOpen("Successfully Version Change ", "successDark");
        });
      // Apply version change
      let resData = restaurantData.map((res) =>
        res.id === id ? { ...res, version: selectedVersion } : res
      );
      dispatch(RestaurantAction.changeStatus(resData));
      if (searchRestaurant.length > 0) {
        let resData = searchRestaurant.map((res) =>
          res.id === id ? { ...res, version: selectedVersion } : res
        );
        console.log("search restaurant data", resData);
        dispatch(RestaurantAction.setSearchRestaurant(resData));
      }
      handleSnackbarOpen("Successfully Version Changed", "successDark");
    } catch (error) {
      console.log("Error applying version:", error);
      handleSnackbarOpen("Error applying version", "errorDark");
    }
  };
  // const handleApplyVersion = (name, id, event) => {
  //   try {
  //     let version = event.target.value;
  //     //   if (selectedNames.length <= 0) {
  //     //     handleSnackbarOpen("Restaurant not selected", "errorDark");
  //     //   }
  //     axios.get(`${process.env.REACT_APP_API_URL}/canary/version`).then((response) => {
  //       if (response && response.data) {
  //         console.log("Response---", response);
  //         console.log("Response---", response.data.data[0]);
  //         console.log("First item from the response:", response.data.data[0]);
  //         setVersion(response.data.data);
  //       }
  //       let resData = restaurantData.map((res) =>
  //         res.id === id ? { ...res, version: response.data.data[0].version } : res
  //       );
  //       dispatch(RestaurantAction.changeStatus(resData));
  //       handleSnackbarOpen("Successfully Version Change ", "successDark");
  //     }).catch((err) => {
  //       console.log("Error---", err);

  //     })
  //     //   axios
  //     //     .post(`${process.env.REACT_APP_API_URL}/restaurant/version`, {
  //     //       names: [{ title: name, id }],
  //     //       version: version,
  //     //     })
  //     //     .then((res) => {
  //     //       let resData = restaurantData.map((res) =>
  //     //         res.id === id ? { ...res, version } : res
  //     //       );
  //     //       dispatch(RestaurantAction.changeStatus(resData));
  //     //       handleSnackbarOpen("Successfully Version Change ", "successDark");
  //     //     });
  //     //   axios
  //     //     .post(`${process.env.REACT_APP_API_URL}/restaurant/version`, {
  //     //       names: [{ title: name, id }],
  //     //       version: version,
  //     //     })
  //     //     .then((res) => {
  //     //       let resData = restaurantData.map((res) =>
  //     //         res.id === id ? { ...res, version } : res
  //     //       );
  //     //       dispatch(RestaurantAction.changeStatus(resData));
  //     //       handleSnackbarOpen("Successfully Version Change ", "successDark");
  //     //     });
  //   } catch (error) {
  //     console.log("error", error);
  //     setSnackbarDetails(error, "errorDark");
  //   }
  // };
  const TableData = (data) => {
    console.log("check rest data", data);
    let tableValues = data?.map((item, index) => ({
      restaurant_id: item.readableId ? item.readableId : "—",
      name: item.restaurantName ? item.restaurantName : "—",
      createdAt: item.createdAt ? getTime(item.createdAt) : "—",
      slug: item.slug ? item.slug : "—",
      version: (
        <FormControl variant="standard" sx={{ m: 2, minWidth: 500 }}>
          {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={item.version}
            onChange={(event) =>
              handleApplyVersion(item.restaurantName, item.id, event)
            }
            label="Age"
          >
            {version.map((data, index) => {
              return (
                <MenuItem key={index} value={data.version}>
                  {data.version}
                </MenuItem>
              );
            })}
            {/* <MenuItem value={"v1"}>V1</MenuItem>
            <MenuItem value={"v2"}>V2</MenuItem> */}
          </Select>
        </FormControl>
      ),
    }));
    return tableValues;
  };

  const columns = [
    {
      name: "restaurant_id",
      label: "Restaurant Id",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "name",
      label: "Restaurant Name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "slug",
      label: "Slug",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "version",
      label: "Version",
      options: {
        filter: true,
        sort: true,
      },
    },
  ];
  const handleClose = () => {
    setopenModal(false);
  };

  const onTableChangeHandler = (action, tableState) => {
    const { page, rowsPerPage, data } = tableState;
    let diff = Math.abs(page * rowsPerPage - data.length);
    if (
      diff <= rowsPerPage &&
      lastEvaluatedkey?.id?.length > 0 &&
      (action === "changePage" || action === "changeRowsPerPage")
    ) {
      dispatch(RestDataAction(lastEvaluatedkey));
      return;
    }
  };
  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <>
          {loadMore && <LoadMoreItems loading={loadMore} />}
          {isOpen.open && (
            <ConfirmationModal
              open={isOpen.open}
              content={isOpen.content}
              item={isOpen.item}
              deleteHandler={isOpen.deleteHandler}
              setIsopen={setisOpen}
            />
          )}
          <div className={classes.newRestDiv}>
            <SearchComp
              endpoint={"restaurant/query"}
              caller={"customer"}
              options={true}
            />
          </div>
          <Table
            data={
              showSearch
                ? TableData(searchRestaurant)
                : TableData(restaurantData)
            }
            columns={columns}
            title="Restaurants"
            onTableChange={onTableChangeHandler}
          />
          {snackbarOpen && (
            <OpenSnackbar
              message={snackbarDetails.message}
              type={snackbarDetails.type}
              open={snackbarOpen}
              setOpen={setSnackbarOpen}
              vertical="bottom"
              horizontal="center"
            />
          )}
        </>
      )}
    </>
  );
}
